<template>
  <div class="actions-col">
    <DotsIcon v-if="!params.hide" :popup-items="params.popupActions" @popup-item="params.onPopupAction($event.name)" />
  </div>
</template>

<script>
import DotsIcon from '@/ui/icons/DotsIcon'

export default {
  components: {
    DotsIcon
  }
}
</script>
